import { createContext, useContext, useState } from 'react';

const AIPromptContext = createContext();

export const useAIPrompt = () => {
  const context = useContext(AIPromptContext);
  if (!context) {
    throw new Error('useAIPrompt must be used within AIPromptProvider');
  }
  return context;
};

export const AIPromptProvider = ({ children }) => {
  const [isPromptMode, setIsPromptMode] = useState(false);
  const [pageMetadata, setPageMetadata] = useState({
    title: '',
    description: '',
    pageType: '',
    url: '',
    content: ''
  });

  const togglePromptMode = () => {
    setIsPromptMode(!isPromptMode);
  };

  const updatePageMetadata = (metadata) => {
    setPageMetadata(metadata);
  };

  const value = {
    isPromptMode,
    togglePromptMode,
    pageMetadata,
    updatePageMetadata
  };

  return (
    <AIPromptContext.Provider value={value}>
      {children}
    </AIPromptContext.Provider>
  );
};
